export const ACTION_GET_LATEST_MY_PRODUCT = '/OrderLines/GetLatestMyProduct';